import { render, staticRenderFns } from "./YandexMaps.vue?vue&type=template&id=3780b38d&"
import script from "./YandexMaps.vue?vue&type=script&lang=js&"
export * from "./YandexMaps.vue?vue&type=script&lang=js&"
import style0 from "./YandexMaps.vue?vue&type=style&index=0&id=3780b38d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports